import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "arrow"]

  toggle() {
    this.listTarget.classList.toggle("hidden")
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.toggle("rotate-180")
    }
  }
}
